/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_Submitted_SuccessfullyInputs */

const en_application_submitted_successfully = /** @type {(inputs: Application_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application submitted successfully!`)
};

const de_application_submitted_successfully = /** @type {(inputs: Application_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbung erfolgreich abgeschickt!`)
};

/**
* | output |
* | --- |
* | "Application submitted successfully!" |
*
* @param {Application_Submitted_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const application_submitted_successfully = /** @type {((inputs?: Application_Submitted_SuccessfullyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_Submitted_SuccessfullyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_submitted_successfully(inputs)
	return en_application_submitted_successfully(inputs)
});